import type { SVGProps } from "react";
const SvgQuillWrite02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M8.792 2.5c-3.21.006-4.892.085-5.966 1.159-1.16 1.16-1.16 3.025-1.16 6.757 0 3.733 0 5.599 1.16 6.758 1.16 1.16 3.025 1.16 6.758 1.16s5.598 0 6.757-1.16c1.074-1.074 1.153-2.755 1.159-5.966"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M9.213 10.833c-.603-7.611 4.789-9.77 9.104-9.03.174 2.523-1.06 3.468-3.41 3.904.454.474 1.256 1.07 1.169 1.817-.062.53-.422.791-1.143 1.312-1.58 1.142-3.411 1.862-5.72 1.997"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M7.5 14.167c1.667-4.584 3.3-6.137 5-7.5"
    />
  </svg>
);
export default SvgQuillWrite02;
